<template>
    <CardContainer>
        <ul class="text-tip mb-7 mt-4 border-b pb-3">
            <li
                v-for="(item ,i) in userData.messageList"
                :key="i"
            >
                {{ item }}
            </li>
        </ul>
        <div class="divide-y divide-gray-100 md:divide-dashed">
            <PolicyAccount
                v-model:isOpenChange="isOpenChange"
                v-model:validInput="validInput"
                v-model:errorResponse="errorResponse"
                :title="showData.payCodeName"
                :dataBase="showData"
                :data="userData"
                :bankOptions="bankOptions"
                :branchOptions="branchOptions"
                @getBranchOptions="getBranchOptions"
                @getValidResult="getValidResult"
            />
        </div>
        <div class="border-t mt-2 pt-6 flex justify-center space-x-4 md:space-x-8">
            <button
                class="btn btn-ghost border border-gray-400 rounded-full mb-3 "
                @click="cancelApply"
            >
                取消申請
            </button>
            <button
                class="btn rounded-full mb-3 sm:px-6 gradient-primary"
                @click="validInput = true"
            >
                下一步
            </button>
        </div>
        <Loading :isLoading="isLoading" />
    </CardContainer>
</template>

<script>
import { computed, inject, reactive, ref, toRefs } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import CardContainer from '@/components/card/CardContainer.vue';
import PolicyAccount from '@/components/template/PolicyAccount.vue';
import routeName from '@/router/constant.js';
import dialogContnet from '@/json/dialogContent.js';
import { getBankInfo, getInfo, postBranchBankInfo, postSubmit } from '@/apis/payAcc.js';
import _ from 'lodash';
import { openPopupCatchMessage } from '@/utils/vfmUtils';

export default {
    components: {
        CardContainer,
        PolicyAccount,
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        // const route = useRoute();
        const router = useRouter();
        const aplCatl = computed(() => store.state.permissions.aplCatl);
        const result = computed(() => store.state.policy.changeItemsResult[aplCatl.value]);
        const loadingCount = ref(false);
        const state = reactive({
            isOpenChange: true,
            isLoading: false,
            isLoadingData: false,
            isSubmitOk: false,
            validInput: false,
        });
        const data = reactive({
            showData: {
                foreignAccount: true,
            },
            userData: {
                headBankNo: '',
                branchBankNo: '',
                bankAccount: '',
                bankAccountName: '',
                errorMessage: {
                    headBankNo: '',
                    branchBankNo: '',
                    bankAccount: '',
                    bankAccountName: '',
                },
                messageList: [],
            },
            bankOptions: [],
            branchOptions: [],
            errorResponse: [],
        });
        const getBranchOptions = (headBankNo) => {
            postBranchBankInfo(aplCatl.value, headBankNo).then((res) => {
                if (res.data) {
                    data.branchOptions = res.data.branchBankInfoList.map(i => {
                        i.value = i.bankNo;
                        i.label = `${i.bankNo} ${i.bankName}`;
                        return i;
                    });
                }
            });
        };
        const getValidResult = (hasError, userData) => {
            state.isLoading = true;
            if (hasError) {
                state.isLoading = false;
                modalShow(dialogContnet.validateMsg);
            } else {
                const returnData = {
                    payCode: userData.payCode,
                    beneFiId: userData.beneFiId,
                    headBankNo: userData.headBankNo,
                    branchBankNo: userData.branchBankNo,
                    bankAccount: userData.bankAccount,
                    bankAccountName: userData.bankAccountName,
                };
                submitData(returnData);
            }
        };
        const submitData = (returnData) => {
            state.isLoading = true;
            postSubmit(aplCatl.value, returnData).then(() => {
                const storeData = {};
                storeData.showData = data.showData;
                storeData.userData = data.userData;
                storeData.bankOptions = data.bankOptions;
                storeData.branchesOptions = data.branchOptions;
                store.dispatch('policy/setChangeItemsResult', {
                    code: aplCatl.value,
                    value: storeData,
                });
                state.isSubmitOk = true;
                router.push({ name: routeName.PAYACC_CONFIRM });
            }).catch((err) => {
                state.isLoading = false;
                const errData = err.data?.details || [];
                if (errData[0]?.field) {
                    data.errorResponse = errData;
                } else {
                    openPopupCatchMessage(err);
                }
            }).finally(() => {
                state.isLoading = false;
            });
        };
        // 取消申請回官網
        const cancelApply = () => {
            const params = dialogContnet.leaveA3A4A5;
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        loadingCount.value += 1;
                        store.dispatch('permissions/goFubonOfficial');
                    },
                    cancel() {
                        $vfm.hide('DialogBase');
                    },
                },
            });
        };

        const getData = () => {
            state.isLoading = true;
            getBankInfo(aplCatl.value).then(res => {
                if (res.data) {
                    data.bankOptions = res.data.bankInfoList.map(i => {
                        i.value = i.bankNo;
                        i.label = `${i.bankNo} ${i.bankName}`;
                        return i;
                    });
                }
            }).catch(err => {
                console.log(err);
            }).finally(() => {
            });

            getInfo(aplCatl.value).then(res => {
                if (res.data) {
                    data.showData = _.cloneDeep(res.data);
                    getMessageList(res.data.payDateTwText);
                }
            }).catch(err => {
                console.log(err);
            }).finally(() => {
                state.isLoading = false;
            });
        };

        const getMessageList = (payDateTwText) => {
            data.userData.messageList = [];
            data.userData.messageList.push('您的保單因給付不成功或未約定要保人給付匯款帳戶，為加快您收到款項的速度，請於下方填寫新的帳號資料。');
            data.userData.messageList.push('指定生效後，本契約各項保險給付，有未指定者，得逕予匯入同一人已指定之帳戶。');
        };

        if (!result.value) {
            getData();
        } else {
            const {
                showData,
                userData,
                bankOptions,
                branchesOptions,
            } = result.value;
            data.showData = _.cloneDeep(showData);
            data.userData = _.cloneDeep(userData);
            data.bankOptions = bankOptions;
            data.branchOptions = branchesOptions;
        }

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                },
            });
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            getBranchOptions,
            getValidResult,
            cancelApply,
            submitData,
        };
    },
};
</script>
